import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './landingpage.css';
import { Row, Col, Avatar } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import localStorage from '../../../../../utils/localStorage';
import { LANDINGPAGE, MASTERIMAGES } from '../../../../../commons/api';
import LayoutAction from '../../../../../modules/actions/LayoutAction';
import { StyledHomepage } from '../../../../../commons/styles/layout';

const StatusLegend = ({ images }) => {
  const avatarStyle = {
    height: '50px',
    width: '50px'
  };
  const statusStyle = {
    color: 'white',
    paddingLeft: '5px',
    fontWeight: 'bold'
  };

  return (
    <Row className="status-legend">
      <Col span={3}></Col>
      {images.map(({ src, label }, i) => (
        <Col key={i} span={5} className="legend-item">
          <Avatar shape="square" src={src} style={avatarStyle} />
          <span style={statusStyle}>{label}</span>
        </Col>
      ))}
    </Row>
  );
};

const DeviceZone = (props) => (
  <div>

    <div className="device-container">
      {props.devices.map((device, idx) => (
        <Col
          key={idx}
          className="device-tile"
          onClick={() => (props.onDeviceClick(device))}
        >
          <div className="device-title">{device.deviceCode}</div>
          <div
            className="device-image"
            style={{ backgroundImage: device.url ? `url(${device.url})` : '' }}
          ></div>
        </Col>
      ))}
    </div>
  </div>
);

const EquipmentOverview = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  // const dispatch = useDispatch();

  const _getdeviceList = () => {
    const siteId = localStorage.get('currentSite') || 'test';
    const accessToken = localStorage.get('accessToken');

    axios({
      method: 'POST',
      url: `${LANDINGPAGE.LandingPageDeviceStatus}?SiteId=${siteId}&ModuleCode=${'Metro_RS'}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: { Type: 'Crane' }
    })
      .then((response) => {
        if (response.data) {
          setDeviceList(response.data);
        }
      })
      .catch(() => {
        // fallback mock data
        // setDeviceList(
        //   [
        //     {
        //       "Zone": "MHC",
        //       "ZoneColor": null,
        //       "ListOfDevices": [
        //         {
        //           "deviceName": "MHC-1",
        //           "deviceCode": "MHC-1",
        //           "Parameter": "MHC_Status",
        //           "status": "stopped",
        //           "url": "/api/masterImages/MHC_V3.png",
        //           "color": "#808080"
        //         },
        //         {
        //           "deviceName": "MHC2",
        //           "deviceCode": "MHC2",
        //           "Parameter": "MHC_Status",
        //           "status": "stopped",
        //           "url": "/api/masterImages/MHC_V3.png",
        //           "color": "#808080"
        //         },
        //         {
        //           "deviceName": "MHC3",
        //           "deviceCode": "MHC3",
        //           "deviceAlias": "1_MHC3",
        //           "Parameter": "MHC_Status",
        //           "url": "/api/masterImages/MHC_Running_v1.png",
        //           "conditions": "Running",
        //           "color": null
        //         }
        //       ]
        //     },
        //     {
        //       "Zone": "QC",
        //       "ZoneColor": null,
        //       "ListOfDevices": [
        //         {
        //           "deviceName": "QC1",
        //           "deviceCode": "QC1",
        //           "Parameter": "QC_Status",
        //           "status": "stopped",
        //           "url": "/api/masterImages/QC_V3.png",
        //           "color": "#808080"
        //         },
        //         {
        //           "deviceName": "QC2",
        //           "deviceCode": "QC2",
        //           "deviceAlias": "1_QC2",
        //           "Parameter": "QC_Status",
        //           "url": "/api/masterImages/QC_Running_V3.png",
        //           "conditions": "Running",
        //           "color": null
        //         },
        //         {
        //           "deviceName": "QC3",
        //           "deviceCode": "QC3",
        //           "deviceAlias": "1_QC3",
        //           "Parameter": "QC_Status",
        //           "url": "/api/masterImages/QC_Running_V3.png",
        //           "conditions": "Running",
        //           "color": null
        //         }
        //       ]
        //     },
        //     {
        //       "Zone": "RTG",
        //       "ZoneColor": null,
        //       "ListOfDevices": [
        //         {
        //           "deviceName": "RTG-01",
        //           "deviceCode": "RTG1",
        //           "deviceAlias": "1_RTG1",
        //           "Parameter": "RTG_Status",
        //           "url": "/api/masterImages/RTG_Idle_V3.png",
        //           "conditions": "Idle",
        //           "color": null
        //         },
        //         {
        //           "deviceName": "RTG-02",
        //           "deviceCode": "RTG2",
        //           "Parameter": "RTG_Status",
        //           "status": "stopped",
        //           "url": "/api/masterImages/RTG_V3.png",
        //           "color": "#808080"
        //         },
        //         {
        //           "deviceName": "RTG-03",
        //           "deviceCode": "RTG3",
        //           "Parameter": "RTG_Status",
        //           "status": "stopped",
        //           "url": "/api/masterImages/RTG_V3.png",
        //           "color": "#808080"
        //         }
        //       ]
        //     }

        //   ]);
      });
  };

  const onCraneImageClick = (craneObject, moduleName) => {
    const moduleRoutes = {
      MHC: ['Modules', '1218', '1220'],
      'QC SVG': ['Modules', '1136', '1138'],
      RTG: ['Modules', '1144', '1146']
    };

    if (moduleName && moduleRoutes[moduleName]) {
      props.layoutAction.setMenuSelection(moduleRoutes[moduleName]);
    }

    props.navigate(craneObject);
  };

  useEffect(() => {
    _getdeviceList();

    const interval = setInterval(() => {
      _getdeviceList();
    }, 60000);

    return () => clearInterval(interval);
  }, []);


  return (
    <StyledHomepage>
      <StatusLegend
        images={[
          { src: MASTERIMAGES.MHC_RUNNING_V1_PNG, label: 'RUNNING' },
          { src: MASTERIMAGES.MHC_IDLE_V1_PNG, label: 'IDLE' },
          { src: MASTERIMAGES.Moblie_Harbour_Crane_V3_PNG, label: 'STOPPED' },
          { src: MASTERIMAGES.MHC_Alert_V1_PNG, label: 'ALERT' }
        ]}
      />
      <DeviceZone
        zoneName="MHC ZONE"
        devices={deviceList[0]?.ListOfDevices || []}
        onDeviceClick={(device) => {
          const path = `/rubus/HMI/distinct/${device.deviceCode}/${device.deviceCode}`;
          onCraneImageClick(path, 'MHC');
        }}
      />

      <StatusLegend
        images={[
          { src: MASTERIMAGES.QC_RUNNING_V3_PNG, label: 'RUNNING' },
          { src: MASTERIMAGES.QC_IDLE_V3_PNG, label: 'IDLE' },
          { src: MASTERIMAGES.QC1_V3_PNG, label: 'STOPPED' },
          { src: MASTERIMAGES.QC1_V3_PNG, label: 'ALERT' }
        ]}
      />
      <DeviceZone
        zoneName="QC ZONE"
        devices={deviceList[1]?.ListOfDevices || []}
        onDeviceClick={() => onCraneImageClick('/rubus/HMI/static/QC SVG', 'QC SVG')}
      />

      <StatusLegend
        images={[
          { src: MASTERIMAGES.RTG_RUNNING_V3_PNG, label: 'RUNNING' },
          { src: MASTERIMAGES.RTG_Idle_V3_PNG, label: 'IDLE' },
          { src: MASTERIMAGES.RTG_CRANE_V3_PNG, label: 'STOPPED' },
          { src: MASTERIMAGES.RTG_Alert_V3_PNG, label: 'ALERT' }
        ]}
      />
      <DeviceZone
        zoneName="RTG ZONE"
        devices={deviceList[2]?.ListOfDevices || []}
        onDeviceClick={() => onCraneImageClick('/rubus/HMI/static/RTG', 'RTG')}
      />
    </StyledHomepage>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutAction: bindActionCreators(LayoutAction, dispatch),
  };
};



export default connect(null, mapDispatchToProps)(EquipmentOverview);
